enum UISubscriptionStatusEnum {
  ActiveSubscription = "ActiveSubscription",
  ActiveCancelledSubscription = "ActiveCancelledSubscription",
  CanceledSubscription = "CanceledSubscription",
  TrialExpiredNoSubscription = "TrialExpiredNoSubscription",
  OnTrialNoSubscription = "OnTrialNoSubscription",
  OnTrialFutureSubscription = "OnTrialFutureSubscription",
  OnIapTrial = "OnIapTrial",
  PaymentError = "PaymentError",
  TrialAvailableNoSubscription = "TrialAvailableNoSubscription",
  HonorarySubscription = "HonorarySubscription",
  HonoraryRecurringSubscription = "HonoraryRecurringSubscription",
  PriceCoupon = "PriceCoupon", // price discounts (amount or percent) and includes coupon information in the metadata
  ImmediateIAPSubscription = "ImmediateIAPSubscription", //  the pending time between user subscribing and the revenuecat webhook arriving in cloud
  ActiveTimeOffPromotion = "ActiveTimeOffPromotion", // had discounted time off and is now in active status but no coupon, pending change, or renewal date.  processor is wahoo
  TrialingTimeOffPromotion = "TrialingTimeOffPromotion", // in trialing status with discounted time off, no coupon, pending change, or renewal date but has a current period start date in future. processor is wahoo
  ActiveSubscriptionWithPendingDowngrade = "ActiveSubscriptionWithPendingDowngrade", // Pro active, Core purchased but not yet active — downgrade takes effect at renewal
}

export default UISubscriptionStatusEnum;
